import {ManagerInfo} from '../../../core/_types'

export const getManagerName = (manager?: ManagerInfo | null) =>
  [manager?.first_name, manager?.last_name].filter(Boolean).join(' ')
